import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import ErrorBoundary from './components/ErrorBoundary';
import { Providers } from './components/Providers';
import { Routes } from './routes';
import { useAuthStore } from './stores';

export const App = () => {
  const profile = useAuthStore((state) => state.profile);

  useEffect(() => {
    if (profile) {
      Sentry.setUser({
        id: `${profile.adminId}`,
        email: profile.email || undefined,
        username: profile.displayName || undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [profile]);

  return (
    <ErrorBoundary>
      <Providers>
        <Routes />
      </Providers>
    </ErrorBoundary>
  );
};
